export const getTranslatedValue = (item, language) => {
    if (!item || !language) {
        return '';
    }

    const translation = item.translations?.find((item) => item.locale === language) ?? { locale: language, value: '' };
    return translation?.value ?? '';
}
